module.exports = __webpack_public_path__ + "static/media/icon-xls.60c82c90.svg";